export default function docPath(api: string): string{
    if(!api){
        return process.env.REACT_APP_DOC_PATH!;
    }
    return process.env.REACT_APP_DOC_PATH+api;
}